import { createSlice } from '@reduxjs/toolkit';
import {
  createJournal,
  deleteJournal,
  fetchJournals,
  updateJournal,
} from './actions';
import { Journal } from './model';

export interface JournalState {
  journals: Journal[];
  loadingJournals: boolean;
  loadingCreateJournal: boolean;
}

const initialState: JournalState = {
  journals: [],
  loadingJournals: false,
  loadingCreateJournal: false,
};

const journalSlice = createSlice({
  name: 'journal',
  initialState,
  reducers: {
    clearJournals: (state) => {
      state.loadingJournals = true;
      state.journals = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJournals.pending, (state) => {
        state.loadingJournals = true;
      })
      .addCase(fetchJournals.fulfilled, (state, actions) => {
        state.journals = actions.payload;
        state.loadingJournals = false;
      })
      .addCase(fetchJournals.rejected, (state) => {
        state.journals = [];
        state.loadingJournals = false;
      })
      .addCase(createJournal.fulfilled, (state) => {
        state.loadingCreateJournal = false;
      })
      .addCase(createJournal.rejected, (state) => {
        state.loadingCreateJournal = false;
      })
      .addCase(createJournal.pending, (state) => {
        state.loadingCreateJournal = true;
      })
      .addCase(updateJournal.fulfilled, (state, action) => {
        const updatedJournals = state.journals.map((journal) =>
          journal.id === action.payload.id ? action.payload : journal
        );
        state.journals = updatedJournals;
      })
      .addCase(deleteJournal.fulfilled, (state, action) => {
        state.journals = state.journals.filter(
          (item) => item.id !== action.meta.arg
        );
      });
  },
});

export default journalSlice.reducer;

export const { clearJournals } = journalSlice.actions;
